import logo from "../../photos/mini-pageIcon.png";
import './AboutV2.css'
import background from './background-about.png'
import {useEffect, useState} from "react";

const AboutV2 = () => {

    const[index, setIndex] = useState(0)
    let testimonies = document.querySelectorAll("div.testimonials")
    const changeTestimony = (e) => {
        e.target.parentNode.childNodes.forEach(dot => {
            if (e.target.isEqualNode(dot)){
                e.target.style.opacity = 1
                setIndex(parseInt(e.target.id.slice(-1)))
            }else{
                dot.style.opacity = 0.3
            }
        })
    }

    useEffect(()=> {
        let i = 0
        testimonies.forEach(testimony => {
            if(index === i)
                testimony.style.display = 'inherit'
            else
               testimony.style.display = 'none'
            ++i;
        })

    })

    return (
        <div id = 'about-us'>
            <div className= 'page-mini-logo'>
                <img alt = 'logo' src = {logo}/>
            </div>
            <h1> About Us </h1>
            <div className= 'about-us-details'>
                <div className=  'about-us-bg-container'>
                    <img src = {background} alt = 'background'/>
                </div>
                <div className= 'testimonials'>
                    <h2> Why did we develop the FARM PPE Project?</h2>
                    <p> Understanding disease risk factors and prevention measures is crucial
                        to the livelihood and well-being of farmers raising livestock and poultry
                        species, and to the health of their animals, no matter the size of the operation.
                        This can be facilitated by developing effective and financially sustainable
                        veterinary-client-patient relationships (VCPR), and providing education on
                        practices that decrease the likelihood of infectious disease. These steps will
                        support the implementation of adequate disease prevention measures and appropriate
                        therapeutic interventions when required.</p>
                </div>

                <div className= 'testimonials'>
                    <h2> Project goals </h2>
                    <div>
                        The goal of the Farm Animal Risk Mitigation Prepare Prevent Evaluate (FARM PPE) Project
                        is to <strong> develop and improve biosecurity measures </strong> on livestock and poultry operations
                        of various scales, including alternative agricultural systems
                        (i.e., small-scale, diversified, and backyard farms), through an outreach program
                        to farmers and ranchers as well as other professionals with whom they work.
                        More specifically, this will be done by:
                        <ul>
                            <li> Creating and providing <strong> tools and resources on biosecurity and infectious disease </strong> for veterinarians and extension educators. These individuals are on the ground, local partners for producers.</li>
                            <li> Organizing a <strong> comprehensive online workshop series </strong> of eight webinars targeted at farmers/producers, veterinarians/extension educators, and 4-H/FFA students across three western states (California, Washington, and Colorado), which will assist participants to create a personalized biosecurity plan for their operation. </li>
                        </ul>
                    </div>
                </div>

                <div className='testimonials'>
                    <h2> Long-term outcomes and broader impacts </h2>
                    <p> This project adds to current state and national efforts and resources to protect animal health, prevent the introduction of foreign animal diseases (FAD), as well as limit the transmission of local pathogens. The partnership between extension educators and veterinarians with producers can improve animal health and sustainability of alternative agriculture systems. </p>
                </div>

                <div className= 'change-testimonials'>
                    <span className = 'dot' id = 'index0' onClick={changeTestimony} />
                    <span className = 'dot' id = 'index1' onClick={changeTestimony} />
                    <span className = 'dot' id = 'index2' onClick={changeTestimony} />
                </div>
            </div>




        </div>
    )
}
export default AboutV2;